type TConfirmModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  title: string;
  message: string;
  confirmText: string;
  cancelText?: string;
};

function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText = "",
}: TConfirmModalProps) {
  return isOpen ? (
    <div className="m-modal m-modal--open m-modal--small">
      <div className="m-modal__dialog">
        {onClose ? (
          <button className="m-modal__close" onClick={onClose}>
            <i className="zmdi zmdi-close"></i>
          </button>
        ) : null}

        <h2 className="m-modal__title">{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: message }}></p>
        <div
          className="m-modal__footer"
          style={{ flexDirection: "row", justifyContent: "flex-end" }}
        >
          {onClose ? (
            <button className="a-button a-button--naked" onClick={onClose}>
              <span>{cancelText}</span>
            </button>
          ) : null}
          {onConfirm ? (
            <button className="a-button" onClick={onConfirm}>
              <span>{confirmText}</span>
            </button>
          ) : null}
        </div>
      </div>
    </div>
  ) : null;
}

export default ConfirmModal;
